var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-result',{attrs:{"title":"Not PDF","subTitle":"抱歉，文件不存在"}},[_c('template',{slot:"icon"},[_c('el-image',{attrs:{"src":"/pdf.png"}})],1),_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){return _vm.backPage()}}},[_vm._v("返回")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }